import { InterpolatedTranslatePipe } from '../../../../pipe/interpolated-translate.pipe';
import { animate, style, transition, trigger } from '@angular/animations';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { Toaster } from '@web/service';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'cas-toast',
  template: `
    @for (toast of toaster.toasts(); track toast) {
      <ngb-toast
        [@slideInOut]
        [autohide]="false"
        [class]="toast.classname">
        @if (toast.template) {
          <ng-template [ngTemplateOutlet]="toast.template"></ng-template>
        } @else {
          <div class="d-flex justify-content-center justify-items-between align-items-center m-2">
            @if (toast.showLoadingSpinner) {
              <cas-spinner
                size="sm"
                class="me-2" />
            }
            <span
              class="text-cloud-white"
              [innerHTML]="toast.text! | translate: toast.translateParams"></span>
            @if (toast.action) {
              <a
                class="ms-3 btn btn-action"
                [ngClass]="'btn-' + toast.type"
                (click)="toast.action.click(); toaster.discard(toast)">
                {{ toast.action.text }}
              </a>
            }
            @if (toast.dismissable) {
              <button
                type="button"
                class="ms-3 btn btn-sm"
                [ngClass]="toast.dismissableClassname"
                (click)="toaster.discard(toast)">
                {{ toast.dismissableText | translate }}
              </button>
            }
          </div>
        }
      </ngb-toast>
    }
  `,
  styles: `
    :host {
      position: fixed;
      top: auto !important;
      right: auto !important;
      left: 50%;
      bottom: 12px;
      margin: 0.5em;
      transform: translateX(-50%);
      z-index: 1200;

      .btn-action {
        filter: drop-shadow(1px 2px 3px rgba(0, 0, 0, 0.2));
      }
    }
  `,
  host: {
    class: 'ngb-toasts',
  },
  imports: [NgbToast, InterpolatedTranslatePipe, NgClass, NgTemplateOutlet, SpinnerComponent],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateY(100%)' }))]),
    ]),
  ],
})
export class Toast {
  readonly toaster = inject(Toaster);
}
